/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import { getActiveQueryName } from "./../util/media-query";

const MediaQueriesStore = {
  namespaced: true,
  state: {
    active: getActiveQueryName()
  },
  getters: {
    active: state => state.active
  },
  mutations: {
    changeActive(state, mediaQueryName) {
      state.active = mediaQueryName;
    }
  },
  actions: {
    /**
     * @memberOf MediaQueriesStore
     * @param commit
     * @param mediaQueryName
     */
    setActive({ commit }, mediaQueryName) {
      commit("changeActive", mediaQueryName);
    }
  }
};

export default MediaQueriesStore;
